import { put, take, all, call, takeEvery } from "redux-saga/effects";

import ModalActions from "modules/modal/modal-actions";
import { normalizeAndStore } from "modules/entity-repository/entity-repository-saga";
import * as Schema from "modules/entity-repository/schema";
import * as API from "modules/modal/modal-api-saga";
import { HelpTextTypes, ModalType } from "modules/modal/modal-constants";
import RootActions from "modules/root/root-actions";
import {
  withErrorHandlingNoRethrow,
  composeSaga
} from "modules/root/saga-helpers";

function* fetchAndStoreHelpText(helpTextKey) {
  const resp = yield call(API.fetchHelpText, helpTextKey);
  yield call(normalizeAndStore, resp.data.data, Schema.helpText);
}

export function* afterLogin() {
  yield all(HelpTextTypes.map(type => call(fetchAndStoreHelpText, type)));
}

export function* runModal(type) {
  yield put(ModalActions.Creators.displayModal(type));
  const closeModalAction = yield take(ModalActions.Types.CLOSE_MODAL);
  return closeModalAction.result;
}

export function* runUnexpectedErrorModal() {
  const result = yield call(runModal, ModalType.UNEXPECTED_ERROR);
  if (result) {
    yield call([window.location, window.location.reload]);
  }
}

function* onUnexpectedError({ exception }) {
  console.warn(exception);
  yield call(runUnexpectedErrorModal);
}

export default function* modalSaga() {
  yield all([
    takeEvery(
      RootActions.Types.UNEXPECTED_ERROR,
      composeSaga(withErrorHandlingNoRethrow, onUnexpectedError)
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/modules/modal/modal-saga.js